import { useAuthorization } from 'components/Authorization';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { stringify } from 'query-string';
import { getLeYanBotHost } from 'services/api/leyanBotHost';

export type EventSourceQuery = Record<string, string>;

export const useEventSource = (path: string = '/overseaim-oms/v1/config/gpt/sse') => {
  const { token } = useAuthorization();

  return function getSource(query: EventSourceQuery) {
    const qs = stringify(query, {
      arrayFormat: 'index',
    });
    const leyanbotHost = getLeYanBotHost();
    const source = new EventSourcePolyfill(`${leyanbotHost}${path}?${qs}`, {
      heartbeatTimeout: 60 * 1000,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return source;
  };
};
